Auth = require 'app/scripts/db/auth'
DragSort = require 'app/scripts/views/lib/drag-sort'
logError = require 'app/scripts/debug/log-error'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
PopOver = require 'app/scripts/views/lib/pop-over'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
boardAllMembersTemplate = require 'app/scripts/views/templates/popover_board_header_all_members'

module.exports = class BoardHeaderAllMembersView extends View
  viewTitleKey: 'board members'

  renderMembers: ->
    newInviteesIds = _.pluck(@options.newInvitees, 'id')
    hasOrg = @model.get('idOrganization')?
    org = @model.getOrganization()
    visibleMembers = @model.orderedVisibleMembers()
    if !(_.any(visibleMembers, (member) => @model.ownedByMember(member)))
      logError new Error("Board had no admins, id = #{@model.id}, #{visibleMembers.length} visibleMembers")

    me = Auth.me()
    isAffiliated = @model.isMember(me) || @model.isObserver(me) || org?.isMember(me)

    groups =
      if isAffiliated
        _.groupBy visibleMembers, (member) =>
          membership = @model.getMembershipFor(member)

          if member.id in newInviteesIds
            'recentlyJoined'
          else if @model.isVirtual(member)
            'invited'
          else if !membership?
            'other'
          else if membership.deactivated
            'deactivated'
          else if membership.memberType == 'observer'
            'observer'
          else if membership.orgMemberType? || (org?.getMembershipFor(member)?)
            'team'
          else if !hasOrg
            'member'
          else
            'other'
      else
        # If we're not affiliated with the board/team (e.g. it's a public board)
        # then we don't need to differentiate between the different sorts of
        # members
        {
          member: _.filter visibleMembers, (member) =>
            membership = @model.getMembershipFor(member)
            return !membership.deactivated && membership.memberType != 'observer'
        }

    memberGroups = [
      { selector: '.js-list-members', list: groups.member }
      { selector: '.js-list-team-members', list: groups.team }
      { selector: '.js-list-recently-joined-members', list: groups.recentlyJoined }
      { selector: '.js-list-invited-members', list: groups.invited }
      { selector: '.js-list-guests', list: groups.other }
      { selector: '.js-list-observers', list: groups.observer }
      { selector: '.js-deactivated-members', list: groups.deactivated }
    ]

    hideHeadings = _.keys(groups).length == 1 && (groups.member? || groups.team?)
    rowMax = 8

    for { selector, list } in memberGroups
      list ?= []
      $section = @$(selector)
      $list = $section.find('.js-list')
      $heading = $section.find('.js-heading')

      $section.toggleClass('is-hidden', list.length == 0)
      $heading.toggleClass('is-hidden', hideHeadings)
      $section.toggleClass('is-partial-row', list.length < rowMax)

      subviews = for member in list
        @subview(MemberOnBoardView, member, { board: @model, pushView: true })

      if $list.length
        @ensureSubviews(subviews, $list)

    @defer ->
      DragSort.refreshDraggableSidebarMembers()

  render: ->
    data =
      canAssign: @model.editable()

    @$el.html boardAllMembersTemplate(data)

    @renderMembers()

    @
